import contract from "./BattleTitans.json"
export const ADDRESS = "0xc5A7e81CFa4c74E61f899CAe09ca10519758F9Fc"
export const { abi: ABI } = contract;